export default async (modul_id, actualRoom, settings) => {
    console.log('%c 💬 CommentsModule Loaded! ', 'background: #222; color: #bada55');

}